import IAddress from '~/interfaces/IAddress';

const { REACT_APP_SIMPLE_ADDRESS, REACT_APP_SIMPLE_ADDRESS_WITHOUT_LOCALITY } =
  process.env;

export default function getAddressFormatted(address: IAddress): string {
  if (!address || !address.road) return 'Retirada no Local';

  if (REACT_APP_SIMPLE_ADDRESS && REACT_APP_SIMPLE_ADDRESS_WITHOUT_LOCALITY) {
    return `${address.road}. nº ${address.number}, ${
      address.neighbourhood || ''
    } ${address.reference || ''}`;
  }

  return REACT_APP_SIMPLE_ADDRESS
    ? `${address.road}, Nº${address.number}, ${address.neighbourhood || ''} ${
        address.reference || ''
      }`
    : `${address.road}, Nº${address.number}, ${address.neighbourhood}, ${
        address.city
      } - ${address.state}. ${address.complement || ''} ${
        address.reference || ''
      }`;
}
